module.exports = __webpack_public_path__ + "static/media/Mouse Scrolldown.3454ae64.svg";